export const CREATED_AT = 'createdAt'
export const POSITION = 'position'
export const PUBLISHED_AT = 'publishedAt'
export const VOTING_RESULT = 'votingResult'
export const ASC = 'asc'
export const DESC = 'desc'

export const VALID_FIELDS = [CREATED_AT, POSITION, PUBLISHED_AT, VOTING_RESULT]
export const VALID_DIRECTIONS = [DESC, ASC]
